import { message } from "antd";
import axiosInstance from "../shared/axios";

const addEditClients = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/updateClient" : "/createClient",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save medicines",
    };
  }
};

const getClientLookups = async () => {
  try {
    let result = await axiosInstance.get("/clientLookups");
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.clients;
    } else {
      message.error("Error while loading clients");
      return null;
    }
  } catch (error) {
    message.error("Error while loading clients");
    return null;
  }
};

const MedicalHistoryAddUpdateClient = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      payload?.id ? "/medical-history/update" : "/medical-history/store",
      {
        ...payload,
        clientID: id || null,
      },
    );

    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to save medical history",
    };
  }
};

const getMedicalHistoryByClientId = async (clientId) => {
  try {
    let result = await axiosInstance.get(
      `/medical-history/viewByClient/${clientId}`,
    );
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading single medical history client");
      return 1;
    }
  } catch (error) {
    console.error("Error fetching single medical history client:", error);
    message.error("Error while loading single medical history client");
    return null;
  }
};

const deleteClient = async (id) => {
  try {
    const result = await axiosInstance.delete(`/deleteClient/${id}`);
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to upload images",
    };
  }
};

// uploading images
const addUploadFiles = async (formData) => {
  try {
    const id = formData.get("id");
    const url = id ? "/client-files/update" : "/client-files/create";

    const result = await axiosInstance.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    }
    return { success: false };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to upload files",
    };
  }
};

const getSingleClientImages = async (clientId) => {
  try {
    const result = await axiosInstance.get(
      `/client-files/viewFiles/${clientId}`,
    );
    console.log("images", result?.data?.data);
    if (result?.data?.success) {
      return result.data.data;
    } else {
      message.error("Error while loading client images");
      return [];
    }
  } catch (error) {
    console.error("Error fetching single client images:", error);
    message.error(
      error?.response?.data?.message || "Error while loading client images",
    );
    return [];
  }
};

const deleteClientImage = async (id) => {
  try {
    const result = await axiosInstance.delete(`/client-files/delete/${id}`);
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete images",
    };
  }
};

export const clientapi = {
  addEditClients,
  getClientLookups,
  MedicalHistoryAddUpdateClient,
  getMedicalHistoryByClientId,
  deleteClient,
  addUploadFiles,
  getSingleClientImages,
  deleteClientImage,
};
